import { render, staticRenderFns } from "./AuditProviderWithRelations.vue?vue&type=template&id=b448b7a2&scoped=true&"
import script from "./AuditProviderWithRelations.vue?vue&type=script&lang=ts&"
export * from "./AuditProviderWithRelations.vue?vue&type=script&lang=ts&"
import style0 from "./AuditProviderWithRelations.vue?vue&type=style&index=0&id=b448b7a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b448b7a2",
  null
  
)

export default component.exports